class ShoppableBentoGrid extends HTMLElement {
  connectedCallback() {
    this.colLeft = this.querySelector('.shoppable-bento__col--left');
    this.colRight = this.querySelector('.shoppable-bento__col--right');
    this.colA = this.querySelector('.shoppable-bento__col--a');
    this.colB = this.querySelector('.shoppable-bento__col--b');
    this.colC = this.querySelector('.shoppable-bento__col--c');

    // Markup renders mobile-first (left/right columns hold the tiles by
    // default); this only needs to reflow into the 3-column desktop
    // layout, and back, when crossing the breakpoint.
    this.isDesktopLayout = false;

    this.mediaQuery = window.matchMedia('(min-width: 750px)');
    this.mediaQuery.addEventListener('change', () => this.layout());
    this.layout();
  }

  layout() {
    const isDesktop = this.mediaQuery.matches;

    if (isDesktop === this.isDesktopLayout) return;

    if (isDesktop) {
      const tile1 = this.colLeft.children[0];
      const tile3 = this.colLeft.children[1];
      const tile2 = this.colRight.children[0];
      const tile4 = this.colRight.children[1];

      if (tile1) this.colA.appendChild(tile1);
      if (tile2) this.colB.appendChild(tile2);
      if (tile3) this.colB.appendChild(tile3);
      if (tile4) this.colC.appendChild(tile4);

      this.isDesktopLayout = true;
    } else {
      const tile1 = this.colA.firstElementChild;
      const tile2 = this.colB.children[0];
      const tile3 = this.colB.children[1];
      const tile4 = this.colC.firstElementChild;

      if (tile1) this.colLeft.appendChild(tile1);
      if (tile3) this.colLeft.appendChild(tile3);
      if (tile2) this.colRight.appendChild(tile2);
      if (tile4) this.colRight.appendChild(tile4);

      this.isDesktopLayout = false;
    }
  }
}

customElements.define('shoppable-bento-grid', ShoppableBentoGrid);
